<template>
  <v-toolbar class="primary elevation-0 small-extension" dark>
    <v-toolbar-side-icon @click.stop="setLeftNav"></v-toolbar-side-icon>
    <v-toolbar-title>Controle de Imóveis</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click.stop="setRightNav">
      <v-icon>search</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
  export default {
    methods: {
      setLeftNav () {
        this.$store.dispatch('template/setLeftNav', true)
      },
      setRightNav () {
        this.$store.dispatch('template/setRightNav', true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HeadersMapa.vue?e0fb5c06